import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BillingFacade, MANAGED_SMART_DEVICES_FEATURES } from '@app/shared/+state/billing';

import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-smart-device-add-on',
  templateUrl: './smart-device-add-on.component.html',
  styleUrls: ['./smart-device-add-on.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartDeviceAddOnComponent implements OnInit {
  public smartDevicePrice$ = this.billingFacade.smartDevicePrice$;
  public canManageAddons$ = this.billingFacade.canManageAddons$;
  public isLegacy$ = combineLatest([this.billingFacade.isOnProfessionalPlan$, this.billingFacade.isOnHostPlan$]).pipe(
    map(([isOnProfessionalPlan, isOnHostPlan]) => !isOnProfessionalPlan && !isOnHostPlan)
  );
  public isDeviceAddonEnabled$ = this.billingFacade.deviceAddonActivated$;
  public features = MANAGED_SMART_DEVICES_FEATURES;
  constructor(private readonly billingFacade: BillingFacade) { }

  ngOnInit(): void {
    this.billingFacade.loadDeviceAddon();
  }
}
